export const BET_STORAGE_STRATEGY = Symbol('BET_STORAGE_STRATEGY');

export interface IBetStorageStrategy {
  save(bet: number): void;
  getSaved(): number | null;
}
